import { motion } from "framer-motion";
import { Star } from "lucide-react";

const items = [
  {
    quote:
      "Green Volt installed a 5kW system on our roof in Port Louis. The team was professional from start to finish.",
    name: "Noorooya Ridhwaan",
    role: "Homeowner, Port Louis",
  },
  {
    quote:
      "Fast, clean and reliable. The hybrid inverter and battery have given us total peace of mind during outages.",
    name: "Jean-Marc L.",
    role: "Business owner, Port Louis",
  },
  {
    quote:
      "Honest advice, fair pricing, and the monitoring app is a pleasure to use. Highly recommended.",
    name: "Anil S.",
    role: "Homeowner, Grand Baie",
  },
];

export function Testimonials() {
  return (
    <section className="py-24 sm:py-32 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-medium text-primary uppercase tracking-widest">
            Testimonials
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight">
            Trusted across Mauritius.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="p-7 rounded-2xl bg-card border border-border"
            >
              <div className="flex gap-0.5 text-accent">
                {Array.from({ length: 5 }).map((_, n) => (
                  <Star key={n} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <blockquote className="mt-4 text-foreground/90 leading-relaxed">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-5 pt-5 border-t border-border">
                <div className="font-semibold">{t.name}</div>
                <div className="text-sm text-muted-foreground">{t.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
